import { PRIMARY_COLOR } from '../../config/color';

interface SVGProps {
  class?: string;
}

export const UserCenterLine = (props: SVGProps) => (
  <svg class={props.class} viewBox="0 0 1 67" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="1" height="67" fill="url(#paint0_linear_7004_3124)" />
    <defs>
      <linearGradient
        id="paint0_linear_7004_3124"
        x1="0.5"
        y1="0"
        x2="0.5"
        y2="67"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E1E6ED" stop-opacity="0" />
        <stop offset="0.49" stop-color="#E1E6ED" />
        <stop offset="0.95" stop-color="#E1E6ED" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export const UserCenterDelete = (props: SVGProps) => (
  <svg class={props.class} viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.36475 4.16992V18.3366H16.8647V4.16992H4.36475Z"
      stroke={PRIMARY_COLOR}
      stroke-linejoin="round"
    />
    <path
      d="M8.94824 8.33789V13.7546"
      stroke={PRIMARY_COLOR}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.2812 8.33789V13.7546"
      stroke={PRIMARY_COLOR}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.28125 4.16992H18.9479"
      stroke={PRIMARY_COLOR}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.28125 4.16992L8.65167 1.66992H12.605L13.9479 4.16992H7.28125Z"
      stroke={PRIMARY_COLOR}
      stroke-linejoin="round"
    />
  </svg>
);

export const UserCenterArrowPrev = (props: SVGProps) => (
  <svg class={props.class} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.1809 4.61873L7.03613 8.76347L11.1809 12.9082"
      stroke="black"
      stroke-width="2"
      stroke-linecap="square"
    />
  </svg>
);

export const UserCenterArrowNext = (props: SVGProps) => (
  <svg class={props.class} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.81913 13.3813L10.9639 9.23653L6.81913 5.0918"
      stroke="black"
      stroke-width="2"
      stroke-linecap="square"
    />
  </svg>
);

export const UserCenterStrategy = (props: SVGProps) => (
  <svg class={props.class} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.1665 18.75H45.8332L24.9998 6.25L4.1665 18.75Z"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M45.8332 43.75H4.1665"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.375 18.75V43.75"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.7915 18.75V43.75"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M30.2085 18.75V43.75"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M40.625 18.75V43.75"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const UserCenterStrategy2 = (props: SVGProps) => (
  <svg class={props.class} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.1665 18.75H45.8332L24.9998 6.25L4.1665 18.75Z"
      fill={PRIMARY_COLOR}
      stroke={PRIMARY_COLOR}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M45.8332 43.75H4.1665"
      stroke={PRIMARY_COLOR}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.375 18.75V43.75"
      stroke={PRIMARY_COLOR}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.7915 18.75V43.75"
      stroke={PRIMARY_COLOR}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M30.2085 18.75V43.75"
      stroke={PRIMARY_COLOR}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M40.625 18.75V43.75"
      stroke={PRIMARY_COLOR}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const UserCenterData = (props: SVGProps) => (
  <svg class={props.class} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M45.8332 24.9993L4.1665 4.16602V45.8327L45.8332 24.9993Z"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.1665 24.9993L45.8332 45.8327V4.16602L4.1665 24.9993Z"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const UserCenterData2 = (props: SVGProps) => (
  <svg class={props.class} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M45.8332 24.9993L4.1665 4.16602V45.8327L45.8332 24.9993Z"
      stroke={PRIMARY_COLOR}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4 25L25 15L45.5 25L24.5 35.5L4 25Z"
      fill={PRIMARY_COLOR}
      stroke={PRIMARY_COLOR}
      stroke-linejoin="round"
    />
    <path
      d="M4.1665 24.9993L45.8332 45.8327V4.16602L4.1665 24.9993Z"
      stroke={PRIMARY_COLOR}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const UserCenterAi = (props: SVGProps) => (
  <svg class={props.class} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27.5566 45.6366L30.5136 36.3486M41.356 45.6366L38.399 36.3486M38.399 36.3486L35.442 27.0605H33.4707L30.5136 36.3486M38.399 36.3486H30.5136"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path d="M45.0713 26V45.6376" stroke="#262626" stroke-width="1.5" stroke-linejoin="round" />
    <path
      d="M44.9385 21.8463C44.9385 16.8718 43.3479 8.7127 32.466 5.72624C20.1808 2.35462 10.4386 11.2314 10.4386 21.8463C10.4386 23.969 6.9888 27.4189 5.26384 29.4092C3.53888 31.3995 10.8366 32.9921 10.8366 32.9921C10.8366 32.9921 10.8366 41.0207 11.7654 44.5356C12.1339 45.9301 23.8398 43.7397 23.8398 43.7397"
      stroke="#262626"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </svg>
);
export const UserCenterAi2 = (props: SVGProps) => (
  <svg class={props.class} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27.5566 45.6366L30.5136 36.3486M41.356 45.6366L38.399 36.3486M38.399 36.3486L35.442 27.0605H33.4707L30.5136 36.3486M38.399 36.3486H30.5136"
      stroke={PRIMARY_COLOR}
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M45.0713 26V45.6376"
      stroke={PRIMARY_COLOR}
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M32.466 5.72624C43.3479 8.7127 44.9385 16.8718 44.9385 21.8463V23.5H30C29.5 23.5 23.8398 43.7397 23.8398 43.7397C23.8398 43.7397 12.1339 45.93 11.7654 44.5356C10.8366 41.0207 10.8366 32.9921 10.8366 32.9921C10.8366 32.9921 3.53888 31.3995 5.26384 29.4092C6.98881 27.4189 10.4386 23.969 10.4386 21.8463C10.4386 11.2314 20.1808 2.35462 32.466 5.72624Z"
      fill={PRIMARY_COLOR}
      stroke={PRIMARY_COLOR}
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </svg>
);
export const UserCenterUseCase = (props: SVGProps) => (
  <svg class={props.class} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M41.6668 20.8327C41.6668 27.924 37.2381 33.981 30.9955 36.3885H25.0002H19.0048C12.7622 33.981 8.3335 27.924 8.3335 20.8327C8.3335 11.6279 15.7954 4.16602 25.0002 4.16602C34.205 4.16602 41.6668 11.6279 41.6668 20.8327Z"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M30.9956 36.3906L30.2882 44.8797C30.2432 45.4196 29.7919 45.8348 29.2501 45.8348H20.7504C20.2086 45.8348 19.7573 45.4196 19.7124 44.8797L19.0049 36.3906"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.75 17.709V23.959L25 20.834L31.25 23.959V17.709"
      stroke="#333333"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const UserCenterUseCase2 = (props: SVGProps) => (
  <svg class={props.class} viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M41.6668 20.8327C41.6668 27.924 37.2381 33.981 30.9955 36.3885H25.0002H19.0048C12.7622 33.981 8.3335 27.924 8.3335 20.8327C8.3335 11.6279 15.7954 4.16602 25.0002 4.16602C34.205 4.16602 41.6668 11.6279 41.6668 20.8327Z"
      fill={PRIMARY_COLOR}
      stroke={PRIMARY_COLOR}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M30.9956 36.3906L30.2882 44.8797C30.2432 45.4196 29.7919 45.8348 29.2501 45.8348H20.7504C20.2086 45.8348 19.7573 45.4196 19.7124 44.8797L19.0049 36.3906"
      stroke={PRIMARY_COLOR}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.75 17.709V23.959L25 20.834L31.25 23.959V17.709"
      stroke="white"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const UserCenterClose = (props: SVGProps) => (
  <svg class={props.class} viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M4.1665 4.16797L20.8332 20.8346"
      stroke="#333333"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.1665 20.8346L20.8332 4.16797"
      stroke="#333333"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const UserCenterTips = (props: SVGProps) => (
  <svg class={props.class} viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 22.5039C14.7614 22.5039 17.2614 21.3846 19.0711 19.575C20.8807 17.7653 22 15.2653 22 12.5039C22 9.74251 20.8807 7.24251 19.0711 5.43284C17.2614 3.6232 14.7614 2.50391 12 2.50391C9.2386 2.50391 6.7386 3.6232 4.92893 5.43284C3.11929 7.24251 2 9.74251 2 12.5039C2 15.2653 3.11929 17.7653 4.92893 19.575C6.7386 21.3846 9.2386 22.5039 12 22.5039Z"
      stroke={PRIMARY_COLOR}
      stroke-width="1.125"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 19.0039C12.6904 19.0039 13.25 18.4443 13.25 17.7539C13.25 17.0636 12.6904 16.5039 12 16.5039C11.3097 16.5039 10.75 17.0636 10.75 17.7539C10.75 18.4443 11.3097 19.0039 12 19.0039Z"
      fill={PRIMARY_COLOR}
    />
    <path
      d="M12 6.50391V14.5039"
      stroke={PRIMARY_COLOR}
      stroke-width="1.125"
      stroke-linecap="square"
    />
  </svg>
);
export const UserCenterSmile = (props: SVGProps) => (
  <svg class={props.class} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_7132_14979)">
      <path
        d="M10 18.3327C14.6024 18.3327 18.3334 14.6017 18.3334 9.99935C18.3334 5.39697 14.6024 1.66602 10 1.66602C5.39765 1.66602 1.66669 5.39697 1.66669 9.99935C1.66669 14.6017 5.39765 18.3327 10 18.3327Z"
        stroke="#9E9E9E"
        stroke-width="1.5"
        stroke-linejoin="round"
      />
      <path
        d="M12.9166 12.916C12.9166 12.916 12.0833 14.5827 9.99998 14.5827C7.91665 14.5827 7.08331 12.916 7.08331 12.916"
        stroke="#9E9E9E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.9167 7.5V9.16667"
        stroke="#9E9E9E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.08331 7.5V9.16667"
        stroke="#9E9E9E"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7132_14979">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export const UserCenterIconTypeUpdate = (props: SVGProps) => (
  <svg class={props.class} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="11.5" fill="#F1F7FF" stroke={PRIMARY_COLOR} />
    <path
      d="M7.89273 10.7568C6.42508 11.1059 5.3335 12.4254 5.3335 13.9998C5.3335 15.8408 6.82588 17.3332 8.66683 17.3332C8.98263 17.3332 9.28816 17.2893 9.57766 17.2072"
      stroke={PRIMARY_COLOR}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.0184 10.7568C17.4861 11.1059 18.5777 12.4254 18.5777 13.9998C18.5777 15.8408 17.0853 17.3332 15.2443 17.3332C14.9285 17.3332 14.623 17.2893 14.3335 17.2072"
      stroke={PRIMARY_COLOR}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16 10.667C16 8.45786 14.2091 6.66699 12 6.66699C9.79087 6.66699 8 8.45786 8 10.667"
      stroke={PRIMARY_COLOR}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.68848 13.2937L12 10.9746L14.3773 13.3334"
      stroke={PRIMARY_COLOR}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 16.667V12.1543"
      stroke={PRIMARY_COLOR}
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
export const UserCenterIconTypePopular = (props: SVGProps) => (
  <svg class={props.class} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="11.5" fill="#FFFCF9" stroke="#EFA917" />
    <path
      d="M12 18.6663C14.7449 18.6663 16.9999 16.4911 16.9999 13.699C16.9999 13.0136 16.9651 12.2788 16.5852 11.1369C16.2052 9.99494 16.1287 9.84754 15.727 9.14231C15.5553 10.5815 14.637 11.1813 14.4037 11.3605C14.4037 11.174 13.8482 9.11164 13.0059 7.87764C12.179 6.66634 11.0545 5.87165 10.3951 5.33301C10.3951 6.35626 10.1073 7.87764 9.69513 8.65281C9.28297 9.42797 9.20557 9.45621 8.69073 10.0331C8.17593 10.6099 7.93963 10.7881 7.50913 11.488C7.07865 12.188 7 13.1203 7 13.8057C7 16.5977 9.2551 18.6663 12 18.6663Z"
      fill="#FFFCF9"
      stroke="#EFA917"
      stroke-linejoin="round"
    />
  </svg>
);
export const UserCenterIconTypeGrowth = (props: SVGProps) => (
  <svg class={props.class} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="12" r="11.5" fill="#FDFFFA" stroke="#74B80C" />
    <path
      d="M11.9997 5.66699L9.96203 9.82619L5.3335 10.4974L8.68646 13.7754L7.88496 18.3337L11.9997 16.1401L16.1153 18.3337L15.3197 13.7754L18.6668 10.4974L14.0639 9.82619L11.9997 5.66699Z"
      stroke="#74B80C"
      stroke-linejoin="round"
    />
  </svg>
);

export const UserCenterTooltips = (props: SVGProps) => (
  <svg
    class={props.class}
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.46143 2.46338C1.30089 3.62394 0.582031 5.22891 0.582031 7.00065C0.582031 8.77239 1.30089 10.3774 2.46143 11.5379C3.62199 12.6985 5.22696 13.4173 6.9987 13.4173C8.77044 13.4173 10.3754 12.6985 11.536 11.5379C12.6965 10.3774 13.4154 8.77239 13.4154 7.00065C13.4154 5.22891 12.6965 3.62394 11.536 2.46338C10.3754 1.30283 8.77044 0.583984 6.9987 0.583984C5.22696 0.583984 3.62199 1.30283 2.46143 2.46338ZM4.66536 5.43294C4.66536 4.14428 5.71004 3.09961 6.9987 3.09961C8.28736 3.09961 9.33203 4.14428 9.33203 5.43294C9.33203 6.52018 8.58841 7.43374 7.58203 7.69277V8.34961C7.58203 8.67178 7.32086 8.93294 6.9987 8.93294C6.67653 8.93294 6.41537 8.67178 6.41537 8.34961V7.18294C6.41537 6.86078 6.67653 6.59961 6.9987 6.59961C7.64303 6.59961 8.16537 6.07727 8.16537 5.43294C8.16537 4.78861 7.64303 4.26628 6.9987 4.26628C6.35437 4.26628 5.83203 4.78861 5.83203 5.43294C5.83203 5.75511 5.57086 6.01628 5.2487 6.01628C4.92653 6.01628 4.66536 5.75511 4.66536 5.43294ZM6.9987 10.9746C6.59599 10.9746 6.26953 10.6481 6.26953 10.2454C6.26953 9.84274 6.59599 9.51628 6.9987 9.51628C7.4014 9.51628 7.72787 9.84274 7.72787 10.2454C7.72787 10.6481 7.4014 10.9746 6.9987 10.9746Z"
      fill="#666666"
    />
  </svg>
);
